/**
 * Styles from https://mapstyle.withgoogle.com/
 * More styles can be found at https://snazzymaps.com/
 */

export const MAP_STYLES = []
